import React, { useState } from "react";
import { Carousel, Button } from "react-bootstrap";
import { motion } from "framer-motion";


const SubsPromoCarousel = ({ promoSlides, interval = 2000, showClose = false, onClose }) => {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
    if (onClose) onClose(); 
  };

  if (!visible) return null;

  return (
    <div className="position-relative rounded" style={{backgroundColor:"#210053"}}>
      {showClose && (
        <i

         className="icofont-close"
          onClick={handleClose}
          style={{
            position: "absolute",
            top: 5,
            right: 5,
            zIndex: 10,
            borderRadius: "50%",
            padding: "0.25rem 0.5rem",
          }}
        >
       
        </i>
      )}
      <Carousel interval={interval} wrap={true} className="mb-5">
        {promoSlides.map((slide, idx) => (
          <Carousel.Item key={idx}>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center p-4"
            >
              <img
                src={slide.img}
                alt={slide.title}
                className="mb-3"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "contain",
                }}
              />
              <h4>{slide.title}</h4>
              <p className="text-muted">{slide.description}</p>
            </motion.div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};


export default SubsPromoCarousel;
